import React from "react";
import {
  Play,
  Building2,
  ShieldCheck,
} from "lucide-react";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";


// function WinnersAbout() {
//   return (
//     <section className="ws-about">
//       {/* same JSX from original component */}
//     </section>
//   );
// }

// export default WinnersAbout;



export function WinnersAbout() {
  return (
    <section className="ws-about">
      <div className="ws-about-glow" />
      <div className="ws-about-inner">
        <div className="ws-about-top">
          <div className="ws-about-text">
            <span className="ws-section-eyebrow">About Winners</span>
            <h2 className="ws-section-heading">
              Smarter real estate experiences — premium living, trusted investments.
            </h2>
            <p>
              Winners is redefining modern property discovery through curated projects,
              transparent investment opportunities, and futuristic community experiences across
              India's top cities.
            </p>
            <div className="ws-about-btns">
              <button className="ws-about-btn solid">Explore more</button>
              <button className="ws-about-btn outline">View properties</button>
            </div>
          </div>

          <div className="ws-about-visual">
            <img src={heroImg} alt="Featured living experience" loading="lazy" width={900} height={1100} />
            <div className="ws-about-play"><Play size={28} fill="currentColor" /></div>
            <div className="ws-about-vcontent">
              <span>Featured experience</span>
              <h4>Luxury spaces crafted for future living</h4>
            </div>
          </div>
        </div>

        <div className="ws-about-bottom">
          <div className="ws-about-side-img">
            <img src={interiorImg} alt="Premium interior" loading="lazy" width={800} height={1000} />
            <div className="ws-about-float">
              <h3>20+</h3>
              <p>Premium cities</p>
            </div>
          </div>

          <div className="ws-about-cards">
            <div className="ws-about-feature">
              <div className="ws-about-feature-ic"><Building2 size={22} /></div>
              <h3>Smart urban communities</h3>
              <p>We design premium residential ecosystems focused on comfort, accessibility and
                strong long-term value.</p>
            </div>
            <div className="ws-about-feature">
              <div className="ws-about-feature-ic"><ShieldCheck size={22} /></div>
              <h3>Verified, transparent listings</h3>
              <p>Every property is vetted, with full ownership trails and clear pricing — no
                surprises, ever.</p>
            </div>
            <div className="ws-about-stats">
              <div className="ws-about-stat"><h3>1L+</h3><p>Verified listings</p></div>
              <div className="ws-about-stat"><h3>1600+</h3><p>Localities</p></div>
              <div className="ws-about-stat"><h3>25Cr+</h3><p>Property value</p></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}